<template>
  <div class="info">
    <user-index-search ref="searchRef" />
    <info-table :detail="detail" />
  </div>
</template>

<script>
import Search from "@/components/dashboard/operation-index/user-index/info/search.vue";
import Table from "@/components/dashboard/operation-index/user-index/info/table.vue";
import { getUserIndexInfoList } from "@/api/dashboard/operation-index/user-index";
import useApi from "@/utils/hooks/use-api";
import { onMounted, ref } from "vue";
export default {
  components: {
    [Search.name]: Search,
    [Table.name]: Table
  },
  setup() {
    const { loading, result, fetchResource } = useApi(getUserIndexInfoList);
    const detail = ref({});
    const searchRef = ref(null);
    const getList = async (params) => {
      const searchParams = searchRef.value.getValues();
      await fetchResource(Object.assign({}, params, searchParams));
      detail.value = result.value.data;
    };
    onMounted(async () => {
      await getList({});
    });
    return {
      getList,
      loading,
      detail,
      searchRef
    };
  }
};
</script>

<style lang="less" scoped>
.info {
  padding: 24px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
}
</style>
